import React from 'react';
import SEOHead from '../components/SEOHead';
import Hero from '../components/Hero';
import HomeContent from '../components/HomeContent';

const Home = ({ selectedPlatform, onPlatformChange }) => {
  return (
    <>
      <SEOHead 
        title="Free YouTube & TikTok Video Downloader - HD, No Watermark | YT DOWN"
        description="Download YouTube and TikTok videos in HD quality without watermarks. Free online video downloader - fast, secure, no registration required. Download MP4, MP3, 4K videos instantly on any device. Works on PC, Mac, Android, iPhone."
        keywords="youtube downloader, tiktok downloader, video downloader, download youtube videos, download tiktok videos, no watermark, hd video download, free video downloader, youtube to mp4, youtube to mp3, tiktok video download, online video downloader, 4k video downloader, youtube shorts downloader, save youtube videos, save tiktok videos, mp4 downloader, mp3 converter, video download online, free youtube downloader, free tiktok downloader, download tiktok without watermark, youtube video saver, tiktok video saver"
        url="https://digimac.pro/"
        image="/logo512.png"
      />
      <Hero selectedPlatform={selectedPlatform} onPlatformChange={onPlatformChange} />
      <HomeContent />
    </>
  );
};

export default Home;
